import React, { FunctionComponent, useState, useEffect } from 'react'
import { Button, Input, notification, Space, Typography } from 'antd'

import Review from '../Review/Review'

import { leaveReviewResponse } from '../../../context/review'

import { IReview, IUser } from '../../../context/types'
import { useCallsListContext } from '../../../context/call/CallsListProvider'

const { TextArea } = Input
const { Title } = Typography

interface ReviewResponseProps {
	review: IReview
	user: IUser
}

const ReviewResponse: FunctionComponent<ReviewResponseProps> = (props) => {
	const { review, user } = props

	const { actions } = useCallsListContext()

	const [message, setMessage] = useState<string>()
	const [loading, setLoading] = useState(false)

	useEffect(() => {
		setMessage('')
		setLoading(false)
	}, [review])

	const handleAction = () => {
		setLoading(true)
		leaveReviewResponse(review.id, message)
			.then(() => {
				notification.success({ message: 'Success' })
				actions.getPast()
			})
			.catch((error) => {
				notification.error({ message: 'Error', description: error.message || 'Oops! Something went wrong!' })
			})
			.finally(() => setLoading(false))
	}

	return (
		<Space direction="vertical" size="large" style={{ width: '100%' }}>
			<Title level={4} style={{ margin: 0 }}>
				About a call
			</Title>
			<Review review={review} user={user} />
			{!review.responce && (
				<>
					<Title type="secondary" level={5} style={{ margin: 0 }}>
						Response
					</Title>
					<TextArea
						autoSize={{ minRows: 4, maxRows: 8 }}
						placeholder={'Please explain your response in detail'}
						value={message}
						onChange={(e) => setMessage(e.target.value)}
					/>
					<Button
						type="primary"
						shape="round"
						size="large"
						onClick={handleAction}
						disabled={!message}
						loading={loading}
					>
						Submit
					</Button>
				</>
			)}
		</Space>
	)
}

export default ReviewResponse
